/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BrandDropDownViewModel } from "../types/BrandDropDownViewModel.ts";

export const brandDropDownViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da marca.")),
  name: z.string().describe("Nome da marca.").nullish(),
}) as unknown as ToZod<BrandDropDownViewModel>;
